import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index.vue'
Vue.use(Router)
const router = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            redirect: '/index'
        },
        {
            path: '/index',
            name: 'of_index',
            component: Index,
            meta: {
                title: '主页'
            }
        },
        {
            path: '/about',
            name: 'of_about',
            meta: {
                title: '关于我们'
            },
            component: resolve => {
                require(['@/pages/about.vue'], resolve)
            }
        },
        {
            path: '/people',
            name: 'of_people',
            meta: {
                title: '人力资源'
            },
            component: resolve => {
                require(['@/pages/people.vue'], resolve)
            }
        },
        {
            path: '/ceo',
            name: 'of_ceo',
            meta: {
                title: '创始人'
            },
            component: resolve => {
                require(['@/pages/ceo.vue'], resolve)
            }
        },
        {
            path: '/project',
            name: 'of_project',
            meta: {
                title: '投资项目'
            },
            component: resolve => {
                require(['@/pages/project.vue'], resolve)
            }
        },
        {
            path: '/friend',
            name: 'of_friend',
            meta: {
                title: '战略合作'
            },
            component: resolve => {
                require(['@/pages/friend.vue'], resolve)
            }
        },
        {
            path: '/news',
            name: 'of_news',
            meta: {
                title: '新闻'
            },
            component: resolve => {
                require(['@/pages/news.vue'], resolve)
            }
        },
    ]
})
export default router